import { IIdentifiable } from 'src/app/models/interfaces/identifiable.interface';
import { FormMode } from '../../controls/common/form-mode';

export class DefaultFormContext<ModelInterface extends IIdentifiable> {
    /**
     * Instance de l'élément affiché dans le formulaire.
     */
    public item: ModelInterface;

    /**
     * Indique si le formulaire est visible (true) ou pas (false).
     */
    public formVisible = false;

    public mode: FormMode = FormMode.Reading;
}
